import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppConfig } from '../../app.config';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
@Component({
  selector: 'app-chc',
  templateUrl: './chc.component.html',
  styleUrls: ['./chc.component.css']
})
export class ChcComponent implements OnInit, OnDestroy {

  userData: any;
  subscription: Subscription;
  showWard = true;
  institutionSubscription: Subscription;

  constructor(public config: AppConfig, public layoutService: PHBHPLayoutPackageService, private router: Router, private listservice: PHBHPListApiService) { }

  ngOnInit() {
    if (this.config.userData.roleName.roleId === 3) {
      this.showWard = false;
      if (this.layoutService.institutionID) {
        this.getinstitutionDetails(this.layoutService.institutionID);
      }
      this.institutionSubscription = this.layoutService.institutionIDSubject.asObservable().subscribe(res => {
        this.getinstitutionDetails(res);
      });
    }
  }

  getinstitutionDetails(institutionid) {
    this.layoutService.showLoader = true;
    this.listservice.getInstitutionsbyId(institutionid, this.config.userData.roleName.roleId).subscribe((res: any) => {
      const selectedInstitution = res.find(x => x.institution.institutionID === institutionid);
      if (selectedInstitution) {
        if (selectedInstitution.institution.isGroup) {
          this.showWard = false;
          if (this.router.url === '/configure/wards') {
            this.router.navigate(['/configure/image-institution']);
          }
        } else {
          this.showWard = true;
        }
      } else {
        this.showWard = true;
      }

    });
    this.layoutService.showLoader = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.institutionSubscription) {
      this.institutionSubscription.unsubscribe();
    }
  }
}
